import { jsx as I } from "react/jsx-runtime";
import * as n from "react";
import { GridStack as F } from "gridstack";
/* empty css                                                                                         */
import { cn as E } from "../../../lib/utils.js";
const V = n.createContext(null), M = () => {
  const e = n.useContext(V);
  if (!e)
    throw new Error("useGridStack must be used within a GridStackLayout");
  return e;
}, J = n.forwardRef(({ id: e, x: m, y: a, w: d = 2, h: u = 2, minW: k, minH: N, maxW: v, maxH: w, noResize: f, noMove: R, locked: S, children: C, className: _ }, G) => {
  const b = n.useRef(null), l = G || b, { registerWidget: p, unregisterWidget: h } = M();
  return n.useEffect(() => {
    const x = l.current;
    return x && p(e, x), () => {
      h(e);
    };
  }, [e, p, h, l]), I("div", { ref: l, className: E("grid-stack-item", _), "gs-id": e, "gs-x": m, "gs-y": a, "gs-w": d, "gs-h": u, "gs-min-w": k, "gs-min-h": N, "gs-max-w": v, "gs-max-h": w, "gs-no-resize": f ? "true" : void 0, "gs-no-move": R ? "true" : void 0, "gs-locked": S ? "true" : void 0, children: I("div", { className: E("grid-stack-item-content", "bg-[var(--bg-surface)] border border-[var(--border-color)] rounded-xl shadow-card overflow-hidden"), children: C }) });
});
J.displayName = "GridStackItem";
const K = n.forwardRef(({ children: e, className: m, column: a = 12, cellHeight: d = 80, margin: u = 10, float: k = !1, animate: N = !0, disableDrag: v = !1, disableResize: w = !1, staticGrid: f = !1, minRow: R = 0, maxRow: S = 0, acceptWidgets: C = !1, removable: _ = !1, onChanged: G, onAdded: b, onRemoved: l, onDragStart: p, onDragStop: h, onResizeStart: x, onResizeStop: z }, y) => {
  const L = n.useRef(null), i = n.useRef(null), W = n.useRef(/* @__PURE__ */ new Map()), [q, U] = n.useState(!1);
  n.useEffect(() => {
    if (!L.current || i.current)
      return;
    const t = {
      column: a,
      cellHeight: d,
      margin: u,
      float: k,
      animate: N,
      disableDrag: v,
      disableResize: w,
      staticGrid: f,
      minRow: R,
      maxRow: S || void 0,
      acceptWidgets: C,
      removable: _
    }, r = F.init(t, L.current);
    return i.current = r, G && r.on("change", (g, s) => {
      G(s);
    }), b && r.on("added", (g, s) => {
      b(s);
    }), l && r.on("removed", (g, s) => {
      l(s);
    }), p && r.on("dragstart", (g, s) => {
      const o = r.getGridItems().find((c) => c === s);
      if (o) {
        const c = o.gridstackNode;
        p(s, c);
      }
    }), h && r.on("dragstop", (g, s) => {
      const o = r.getGridItems().find((c) => c === s);
      if (o) {
        const c = o.gridstackNode;
        h(s, c);
      }
    }), x && r.on("resizestart", (g, s) => {
      const o = r.getGridItems().find((c) => c === s);
      if (o) {
        const c = o.gridstackNode;
        x(s, c);
      }
    }), z && r.on("resizestop", (g, s) => {
      const o = r.getGridItems().find((c) => c === s);
      if (o) {
        const c = o.gridstackNode;
        z(s, c);
      }
    }), U(!0), () => {
      r.destroy(!1), i.current = null, U(!1);
    };
  }, []), n.useEffect(() => {
    const t = i.current;
    t && (t.batchUpdate(), t.column(a), t.cellHeight(d), t.margin(u), t.float(k), t.enableMove(!v && !f), t.enableResize(!w && !f), t.batchUpdate(!1));
  }, [a, d, u, k, v, w, f]);
  const j = n.useCallback((t, r) => {
    W.current.set(t, r), i.current && i.current.makeWidget(r);
  }, []), P = n.useCallback((t) => {
    const r = W.current.get(t);
    r && i.current && i.current.removeWidget(r, !1), W.current.delete(t);
  }, []), B = n.useMemo(() => ({
    grid: i.current,
    registerWidget: j,
    unregisterWidget: P
  }), [j, P, q]);
  return I(V.Provider, { value: B, children: I("div", { ref: (t) => {
    L.current = t, typeof y == "function" ? y(t) : y && (y.current = t);
  }, className: E("grid-stack", m), children: e }) });
});
K.displayName = "GridStackLayout";
const Y = () => {
  const { grid: e } = M();
  return e;
}, Z = () => {
  const { grid: e } = M(), m = n.useCallback(() => e ? e.save(!1) : [], [e]), a = n.useCallback((u) => {
    e && e.load(u);
  }, [e]), d = n.useCallback(() => {
    e && e.compact();
  }, [e]);
  return { saveLayout: m, loadLayout: a, compact: d };
};
export {
  J as GridStackItem,
  K as GridStackLayout,
  M as useGridStack,
  Y as useGridStackInstance,
  Z as useGridStackLayout
};
//# sourceMappingURL=GridStack.js.map
